/**
 * StepTracker.jsx
 * Animated real-time pipeline step indicator.
 * Shows each stage of the agent pipeline as it happens.
 */

import React from "react";
import "../ChatPage.css";

const STEP_CONFIG = {
  thinking:    { icon: "🧠", label: "Analyzing your query" },
  agent:       { icon: "🤖", label: "Consulting agent" },
  calling_api: { icon: "🔗", label: "Fetching data" },
  processing:  { icon: "📊", label: "Processing results" },
  error:       { icon: "⚠️", label: "Error occurred" },
};

export default function StepTracker({ steps }) {
  if (!steps || steps.length === 0) return null;

  return (
    <div className="hn-message-row hn-bot-row">
      <div className="hn-avatar hn-bot-avatar" title="HireNeuron AI">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" rx="6" fill="#6366f1" fillOpacity="0.2" />
          <path
            d="M12 4C7.58 4 4 7.58 4 12s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm-1 10H9V8h2v6zm4 0h-2V8h2v6z"
            fill="#6366f1"
          />
        </svg>
      </div>

      <div className="hn-step-tracker">
        {steps.map((step, i) => {
          const config = STEP_CONFIG[step.step] || { icon: "⚙️", label: step.step };
          const isLast = i === steps.length - 1;
          const isDone = !isLast;

          return (
            <div
              key={i}
              className={`hn-step ${isDone ? "hn-step-done" : "hn-step-active"}`}
            >
              <span className="hn-step-icon">
                {isDone ? (
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                ) : (
                  <span className="hn-step-emoji">{config.icon}</span>
                )}
              </span>
              <span className="hn-step-label">
                {step.detail || config.label}
              </span>
              {!isDone && <span className="hn-step-spinner" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}
